import { useState } from "react";
import axios from "axios";

const useAxios = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const callAPI = async (url, method = "GET", payload = null, headers = {}) => {
    setLoading(true);
    setError(null);
    console.log(headers);
    try {
      const response = await axios({
        url,
        method,
        data: payload,
        headers,
      });

       let parsedData = response.data;

      if (typeof parsedData === "string") {
        try {
          parsedData = JSON.parse(parsedData);
        } catch (_) {
        }
      }

      setData(parsedData);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { data, error, loading, callAPI };
};

export default useAxios;
